import {
  RetrievePropertyByIdUrl,
  CreateFeedbackRequest
} from '../utils/agentUrls'
import {
  genericGetRequestToApi,
  genericPostRequestToApi,
  genericPutRequestToApi,
  genericDeleteRequestToApi
} from '../utils/genericRequests'
import {
  CreateFavoriteUrl,
  UpdateDeleteFavoriteUrl
} from '../utils/clientUrls'

/**
 * receives data about property by property id
 * @param {ObjectId} id - Property Id in the system
 */
const getPropertyById = id =>
  genericGetRequestToApi(RetrievePropertyByIdUrl(id))

/**
 * assigns a property as favorite for a client
 * @param {String} clientId - client id to which property is assigned
 * @param {String} propertyId - id of property
 */
const createFavoriteProperty = (clientId, propertyId) =>
  genericPostRequestToApi(CreateFavoriteUrl(clientId, propertyId))

/**
 * Adds property to given user's favorite list
 * @param {String} profileId - user profile id
 * @param {String} favId - id of selected property
 */
const createFeedbackRequest = (profileId, homeId) =>
  genericPostRequestToApi(CreateFeedbackRequest(profileId, homeId))

/**
 * Sets request tour to true for given property of user
 * @param {String} clientId - user profile id
 * @param {String} favId - id of requested property
 */
const requestTourRequest = (clientId, favId) =>
  genericPutRequestToApi(UpdateDeleteFavoriteUrl(clientId, favId), null, {
    params: { requestTour: true }
  })

/**
 * Removes a property from client favorite list
 * @param {String} clientId - client id
 * @param {String} favId - id of property to be removed
 */
const deleteFavoriteRequest = (clientId, favId) =>
  genericDeleteRequestToApi(UpdateDeleteFavoriteUrl(clientId, favId))

const setPropertyasClientFavorite = async (
  clientData,
  clientFavorites,
  property
) => {
  const response = await createFavoriteProperty(clientData._id, property._id)
  if (response.status === 201) {
    const updatedFavProperty = {
      ...property,
      ...response.data,
      favoriteId: response.data._id,
      _id: property._id
    }
    const updatedClientHomes = [response.data, ...clientData.homes]
    const updatedClientFavs = [updatedFavProperty, ...clientFavorites]
    return { updatedClientHomes, updatedClientFavs }
  } else if (response.status === 409) {
    // TODO error handling
    console.log('That property already exists in that client favorite list')
  } else {
    console.log('some error occurred')
  }
  return null
}

const removeFromClientFavorite = async (
  clientData,
  clientFavorites,
  selectedHome
) => {
  const response = await deleteFavoriteRequest(
    clientData._id,
    selectedHome.favoriteId
  )

  if (response.status === 200) {
    const updatedClientHomes = clientData.homes.filter(
      home => home.propertyId !== selectedHome._id
    )
    const updatedClientFavs = clientFavorites.filter(
      fav => fav._id !== selectedHome._id
    )
    return { updatedClientHomes, updatedClientFavs }
  } else {
    console.log('error')
  }
  return null
}

const requestPropertyTour = async (
  clientData,
  clientFavorites,
  selectedHome
) => {
  const response = await requestTourRequest(
    clientData._id,
    selectedHome.favoriteId
  )

  if (response.status === 200) {
    const updatedClientHomes = clientData.homes.map(home => {
      return home._id === selectedHome.favoriteId ? { ...response.data } : home
    })
    const updatedClientFavs = clientFavorites.map(fav => {
      return fav._id === selectedHome.propertyId
        ? {
          ...fav,
          ...response.data,
          favoriteId: response.data._id,
          _id: fav._id
        }
        : fav
    })
    return { updatedClientHomes, updatedClientFavs }
  } else {
    console.log('some error occurred')
  }
  return null
}

export {
  getPropertyById,
  createFavoriteProperty,
  createFeedbackRequest,
  setPropertyasClientFavorite,
  requestTourRequest,
  requestPropertyTour,
  removeFromClientFavorite
}
